var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIdCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.303,
    height: 14.194,
    viewBox: "0 0 18.303 14.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(-0.001 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(0.001 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M9.19,14.19c-2.39,0-4.782.007-7.172,0a1.946,1.946,0,0,1-1.592-.791A1.942,1.942,0,0,1,.01,12.208C0,10.791,0,9.373,0,7.955,0,5.979,0,4,.005,2.024a2.1,2.1,0,0,1,.262-.971A1.976,1.976,0,0,1,1.213.17,1.324,1.324,0,0,1,1.768.024C2.392.021,3.016,0,3.641,0Q9.508,0,15.377,0c.393,0,.787.013,1.181.026a1.657,1.657,0,0,1,.885.34,1.955,1.955,0,0,1,.77,1.067,1.881,1.881,0,0,1,.092.577q0,5.153,0,10.306c0,.127-.075.253-.084.381a1.085,1.085,0,0,1-.181.469,1.9,1.9,0,0,1-1.252.96,2.478,2.478,0,0,1-.532.062Q12.72,14.194,9.19,14.19ZM9.164,1.482h0q-3.4,0-6.805,0c-.119,0-.238.006-.356.013a.508.508,0,0,0-.409.23.7.7,0,0,0-.1.427q0,4.1,0,8.2c0,.6,0,1.207,0,1.811a.531.531,0,0,0,.483.531c.084,0,.169.015.253.015H16.115a2.557,2.557,0,0,0,.274-.021.47.47,0,0,0,.414-.463c-.006-.064,0-.129,0-.193q0-4.909,0-9.818c0-.1,0-.2-.006-.3a.383.383,0,0,0-.223-.338,1.106,1.106,0,0,0-.547-.087q-3.434,0-6.866,0Z",
    transform: "translate(-0.001 0.003)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M41.342,102.527c-.971,0-1.942,0-2.913,0a1.421,1.421,0,0,1-.36-.056.346.346,0,0,1-.258-.329,2.379,2.379,0,0,1,.19-1.148,2.216,2.216,0,0,1,.554-.8,2.471,2.471,0,0,1,.925-.551,4.3,4.3,0,0,1,1.319-.131c.462,0,.924-.006,1.386,0a3.7,3.7,0,0,1,.738.059,2.406,2.406,0,0,1,.991.464,2.482,2.482,0,0,1,.684.846,3.226,3.226,0,0,1,.172.508,2.074,2.074,0,0,1,.092.6.5.5,0,0,1-.558.539c-.988,0-1.976,0-2.964,0Z",
    transform: "translate(-34.711 -91.371)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M60.345,39.263a2.013,2.013,0,0,1-4.025-.022,2.013,2.013,0,1,1,4.025.022Z",
    transform: "translate(-51.716 -34.184)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M139.484,43.47c.407,0,.815,0,1.222,0a.989.989,0,0,1,.468.119.541.541,0,0,1,.222.229.748.748,0,0,1-.65,1.149c-.828,0-1.657,0-2.485-.01a.748.748,0,0,1-.523-.186.725.725,0,0,1-.226-.642.665.665,0,0,1,.283-.515.746.746,0,0,1,.436-.144c.418,0,.835,0,1.252,0Z",
    transform: "translate(-126.266 -39.916)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M139.435,82.228H138.1a.619.619,0,0,1-.612-.422.88.88,0,0,1,.02-.627.628.628,0,0,1,.455-.371,1.29,1.29,0,0,1,.32-.045q1.155-.006,2.311,0a.824.824,0,0,1,.7.3.988.988,0,0,1,.11.267.476.476,0,0,1,.035.156.7.7,0,0,1-.685.748c-.441-.008-.882,0-1.324,0Z",
    transform: "translate(-126.204 -74.157)",
    fill: "#434343"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCard);
export default __webpack_public_path__ + "static/media/icon-idCard.d58430e1005919a4456b4b03f39510b2.svg";
export { ForwardRef as ReactComponent };